import React, { Fragment, useState } from 'react';
import estilos from './TabRelacionesComponet.module.css'
import ProductoresComponet from './ProductoresComponet';
import { useDispatch, useSelector } from 'react-redux'
import { obtenerTodasLasRelacionesMaquiladorClientes, obtenerTodasLasRelacionesProductorClientes } from '../../../../redux/DucksAtencionACliente/ModuloConsultaDucks';
import Button from '@mui/material/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquarePlus } from '@fortawesome/free-solid-svg-icons/faSquarePlus';
import Icon from '@mui/material/Icon';
import ModalRelacionesComponet from './ModalRelacionesComponet';
import MaquiladoresComponet from './MaquiladoresComponet';
import { ThemeProvider, createTheme } from '@mui/material/styles';

function TabsRelaciones(props) {

  let detalleCliente = props?.detalleCliente

  const dispatch = useDispatch()

  const [activeTab, setActiveTab] = useState('content1');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  const [productores, setProductores] = useState([]);
  const [maquiladores, setMaquiladores] = useState([]);

  const theme = createTheme({
    palette: {
      primary: {
        main: "#EDB75A"
      },
      secondary: {
        main: "#DC3545"
      }
    },
    typography: {
      fontFamily: "Montserrat",
      textTransform: 'none',
      button: {
        fontSize: 16,
        fontWeight: 500,
        fontFamily: "Montserrat",
        textTransform: 'none',

      }
    }
  });

  React.useEffect(async () => {
    if (activeTab == 'content1') {
      let productor = await dispatch(obtenerTodasLasRelacionesProductorClientes(detalleCliente?.idcliente))
      setProductores(productor.payload)
    }
    if (activeTab == 'content2') {
      let productor = await dispatch(obtenerTodasLasRelacionesMaquiladorClientes(detalleCliente?.idcliente))
      setMaquiladores(productor.payload)
    }
  }, [])


  const marcasUnidas = [...detalleCliente?.marcascliente, ...detalleCliente?.marcasproductoconmezcalcliente];

  const [openModal, setOpenModal] = useState(false);
  const [tipoRelacion, setTipoRelacion] = useState('');
  const [editar, setEditar] = useState(false);
  const [dataEditar, setDataEditar] = useState('');
  const [eliminar, setEliminar] = useState(false);

  React.useEffect(async () => {
    //if (activeTab == 'content1') {
      let productor = await dispatch(obtenerTodasLasRelacionesProductorClientes(detalleCliente?.idcliente))
      setProductores(productor.payload)
   // }
    //if (activeTab == 'content2') {
      let maquilador = await dispatch(obtenerTodasLasRelacionesMaquiladorClientes(detalleCliente?.idcliente))
      setMaquiladores(maquilador.payload)
    //}
    setEliminar(false)
  }, [openModal, activeTab, eliminar])

  return (
    <Fragment>
      <ThemeProvider theme={theme}>
        <div className={estilos.tabs}>
          <nav className={estilos.nav}>
            <a className={activeTab == 'content1' ? estilos.a1 : estilos.a1} href="#content1" onClick={() => handleTabClick('content1')}> PRODUCTOR </a>
            <a className={activeTab == 'content2' ? estilos.a1 : estilos.a1} href="#content2" onClick={() => handleTabClick('content2')}> MAQUILADOR </a>
          </nav>
          <div className='row'>
            <div className={estilos.content} id="content1" /*style={{ display: activeTab === 'content1' ? 'block' : 'none' }}*/>
              <div className='row'>
                <div className='col-7'></div>
                <div className='col-5' style={{ textAlign: 'end' }}>
                </div>
              </div>
              <ProductoresComponet relacionProductor={productores} setEditar={setEditar} setOpenModal={setOpenModal} setTipoRelacion={setTipoRelacion} setDataEditar={setDataEditar}
                setEliminar={setEliminar} />
            </div>
            <div className={estilos.content} id="content2" /*style={{ display: activeTab === 'content2' ? 'block' : 'none' }}*/>
              <div className='row'>
                <div className='col-7'></div>
                <div className='col-5' style={{ textAlign: 'end' }}>
                </div>
              </div>
              <MaquiladoresComponet relacionMaquilador={maquiladores} setEditar={setEditar} setOpenModal={setOpenModal} setTipoRelacion={setTipoRelacion} setDataEditar={setDataEditar}
                setEliminar={setEliminar} />
            </div>
          </div>

        </div>
        {openModal &&
          <ModalRelacionesComponet marcas={marcasUnidas?.filter(anexo => anexo.isbaja == false)} setOpenModal={setOpenModal} tipoRelacion={tipoRelacion} setTipoRelacion={setTipoRelacion}
            detalleCliente={detalleCliente} editar={editar} setEditar={setEditar} dataEditar={dataEditar} />
        }
      </ThemeProvider>
    </Fragment>

  );
}

export default TabsRelaciones;